import { useState, useRef, useEffect } from "react";
import "./GetStarted.css";

// CCTV
import cctv from "../../assets/servicesimgs/cctv.png";
import cctv1 from "../../assets/servicesimgs/cctv1.png";
import cctv2 from "../../assets/servicesimgs/cctv2.png";
import cctv3 from "../../assets/servicesimgs/cctv3.png";

import intercom from "../../assets/servicesimgs/intercom.png";
import intercom1 from "../../assets/servicesimgs/intercom1.png";
import intercom2 from "../../assets/servicesimgs/intercom2.png";
import intercom3 from "../../assets/servicesimgs/intercom3.png";

import cabling from "../../assets/servicesimgs/cabling.png";
import cabling1 from "../../assets/servicesimgs/cabling1.png";
import cabling2 from "../../assets/servicesimgs/cabling2.png";
import cabling3 from "../../assets/servicesimgs/cabling3.png";

import catv from "../../assets/servicesimgs/catv.png";
import catv1 from "../../assets/servicesimgs/catv1.png";
import catv2 from "../../assets/servicesimgs/catv2.png";
import catv3 from "../../assets/servicesimgs/catv3.png";

import paging from "../../assets/servicesimgs/paging.png";
import paging1 from "../../assets/servicesimgs/paging1.png";
import paging2 from "../../assets/servicesimgs/paging2.png";
import paging3 from "../../assets/servicesimgs/paging3.png";

import firesystem from "../../assets/servicesimgs/firesystem.png";
import firesystem1 from "../../assets/servicesimgs/firesystem1.png";
import firesystem2 from "../../assets/servicesimgs/firesystem2.png";
import firesystem3 from "../../assets/servicesimgs/firesystem3.png";

import wifi from "../../assets/servicesimgs/wifi.png";
import wifi1 from "../../assets/servicesimgs/wifi1.png";
import wifi2 from "../../assets/servicesimgs/wifi2.png";
import wifi3 from "../../assets/servicesimgs/wifi3.png";

const sections = [
  {
    title: "Access Point / Wi-Fi",
    desc: "Reliable safety alarm systems designed for building protection.",
    images: [wifi2, wifi3, wifi1, wifi],
  },
  {
    title: "CATV System",
    desc: "Organized cabling solutions for clean and efficient networks.",
    images: [catv2, catv3, catv1, catv],
  },
  {
    title: "CCTV System",
    desc: "Professional CCTV systems designed for security and reliability.",
    images: [cctv, cctv1, cctv2, cctv3],
  },
  {
    title: "Fire Alarm and Detection System",
    desc: "Reliable safety alarm systems designed for building protection.",
    images: [firesystem, firesystem1, firesystem2, firesystem3],
  },
  {
    title: "Intercom System",
    desc: "Smart building solutions for modern infrastructure.",
    images: [intercom, intercom1, intercom2, intercom3],
  },
  {
    title: "BGMPA / Paging System",
    desc: "Reliable safety alarm systems designed for building protection.",
    images: [paging, paging1, paging2, paging3],
  },
  {
    title: "Structured Cabling – Data & Voice",
    desc: "Reliable wired and wireless network installations.",
    images: [cabling1, cabling, cabling2, cabling3],
  },
];

const GetStartedSection = ({ title, desc, images, onRequest }) => {
  const [bgImage, setBgImage] = useState(images[0]);
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={sectionRef}
      className={`getstarted-section ${visible ? "slide-in" : ""}`}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="section-text">
        <h2>{title}</h2>
        <p>{desc}</p>
        <button className="section-btn" onClick={() => onRequest(title)}>
          Book a Consultation
        </button>
      </div>

      <div className="getstarted-thumbnail-carousel">
        {images.map((img, index) => (
          <div
            key={index}
            className={`getstarted-thumbnail ${bgImage === img ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
            onClick={() => setBgImage(img)}
          />
        ))}
      </div>
    </div>
  );
};

const GetStarted = () => {
  const containerRef = useRef(null);
  const [selectedService, setSelectedService] = useState(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  // Form states
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [website, setWebsite] = useState(""); // honeypot
  const [status, setStatus] = useState(null); // null | "sending" | "success" | "error"

  // Focus states for floating labels
  const [nameFocus, setNameFocus] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);
  const [phoneFocus, setPhoneFocus] = useState(false);
  const [messageFocus, setMessageFocus] = useState(false);

  const updateScrollButtons = () => {
    const container = containerRef.current;
    if (!container) return;
    setCanScrollLeft(container.scrollLeft > 0);
    setCanScrollRight(
      container.scrollLeft + container.offsetWidth < container.scrollWidth
    );
  };

  useEffect(() => {
    const container = containerRef.current;

    const handleWheel = (e) => {
      e.preventDefault();
      container.scrollLeft += e.deltaY;
    };

    container.addEventListener("wheel", handleWheel, { passive: false });
    container.addEventListener("scroll", updateScrollButtons);
    updateScrollButtons();

    return () => {
      container.removeEventListener("wheel", handleWheel);
      container.removeEventListener("scroll", updateScrollButtons);
    };
  }, []);

  const scrollTo = (direction) => {
    const container = containerRef.current;
    const sectionWidth = container.offsetWidth;
    if (direction === "left") container.scrollLeft -= sectionWidth;
    else container.scrollLeft += sectionWidth;
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !phone) {
      setStatus("error");
      setTimeout(() => setStatus(null), 4000);
      return;
    }

    setStatus("sending");

    const payload = {
      name,
      email,
      phone,
      service: selectedService,
      message,
      website, // honeypot
    };

    try {
      const res = await fetch(
        "https://api.kemari-corp.com/service_request.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        setStatus("success");
        setName("");
        setEmail("");
        setPhone("");
        setMessage("");
        setWebsite("");
      } else {
        setStatus("error");
        setTimeout(() => setStatus(null), 4000);
      }
    } catch (err) {
      console.error(err);
      setStatus("error");
      setTimeout(() => setStatus(null), 4000);
    }
  };

  return (
    <>
      <div className="getstarted-wrapper">
        <div className="getstarted-container" ref={containerRef}>
          {sections.map((section, index) => (
            <GetStartedSection
              key={index}
              {...section}
              onRequest={(service) => setSelectedService(service)}
            />
          ))}
        </div>

        <div className="getstarted-nav-outside">
          <button onClick={() => scrollTo("left")} disabled={!canScrollLeft}>
            &lt;
          </button>
          <button onClick={() => scrollTo("right")} disabled={!canScrollRight}>
            &gt;
          </button>
        </div>
      </div>

      {/* FULLSCREEN FORM */}
      {selectedService && (
        <div className="request-fullscreen">
          <div className="request-fullscreen-content">
            <button
              className="form-back-btn"
              onClick={() => { setSelectedService(null); setStatus(null); }}
            >
              ✕
            </button>

            <div className="form-header">
              <span className="form-eyebrow">Request Service</span>
              <h2>Book a Consultation</h2>
              <p className="form-subtext">
                Tell us about your project and we'll get back to you.
              </p>
            </div>

  <form onSubmit={handleSubmit} className="form-minimal" noValidate>
              {/* HONEYPOT FIELD */}
              <input
                type="text"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
                style={{ display: "none" }}
              />

              {/* SERVICE FIELD */}
              <div className="form-field form-field--readonly">
                <label className="form-label form-label--active">Service</label>
                <input
                  type="text"
                  className="form-input"
                  value={selectedService}
                  readOnly
                />
                <span className="form-underline"></span>
              </div>

              {/* NAME FIELD */}
              <div className={`form-field ${nameFocus ? "is-focused" : ""} ${name ? "has-value" : ""}`}>
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  className="form-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={() => setNameFocus(true)}
                  onBlur={() => setNameFocus(false)}
                  required
                />
                <span className="form-underline"></span>
              </div>

              {/* EMAIL FIELD */}
              <div className={`form-field ${emailFocus ? "is-focused" : ""} ${email ? "has-value" : ""}`}>
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  className="form-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onFocus={() => setEmailFocus(true)}
                  onBlur={() => setEmailFocus(false)}
                  required
                />
                <span className="form-underline"></span>
              </div>

              {/* PHONE FIELD */}
              <div className={`form-field ${phoneFocus ? "is-focused" : ""} ${phone ? "has-value" : ""}`}>
                <label className="form-label">Phone Number</label>
                <input
                  type="tel"
                  className="form-input"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  onFocus={() => setPhoneFocus(true)}
                  onBlur={() => setPhoneFocus(false)}
                  required
                />
                <span className="form-underline"></span>
              </div>

              {/* MESSAGE FIELD */}
              <div className={`form-field form-field--area ${messageFocus ? "is-focused" : ""} ${message ? "has-value" : ""}`}>
                <label className="form-label">Project Details</label>
                <textarea
                  className="form-textarea"
                  rows="5"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onFocus={() => setMessageFocus(true)}
                  onBlur={() => setMessageFocus(false)}
                />
                <span className="form-underline"></span>
              </div>

              {/* SUBMIT ROW */}
              <div className="form-submit-row">
                <button
                  type="submit"
                  className={`form-submit ${status === "sending" ? "is-sending" : ""}`}
                  disabled={status === "sending"}
                >
                  <span>{status === "sending" ? "Sending…" : "Send Request"}</span>
                  <svg className="form-submit-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </button>
              </div>

              {/* STATUS MESSAGES */}
              {status === "success" && (
                <div className="form-status-msg form-status-msg--ok">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M9 12l2 2 4-4M12 3a9 9 0 100 18A9 9 0 0012 3z" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>
                    <p className="form-status-title">Request sent!</p>
                    <p className="form-status-sub">We'll get back to you shortly.</p>
                  </div>
                </div>
              )}

              {status === "error" && (
                <div className="form-status-msg form-status-msg--err">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M12 9v4m0 4h.01M12 3a9 9 0 100 18A9 9 0 0012 3z" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>
                    <p className="form-status-title">Please check required fields.</p>
                    <p className="form-status-sub">Name, email, and phone are required.</p>
                  </div>
                </div>
              )}

            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default GetStarted;